import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';

import { Link, useNavigate } from 'react-router-dom';

import { useCallback, useMemo, type ElementType } from 'react';

import { useToken } from 'hooks/useToken';

import Route from 'routes/Route';

import { useUser } from 'hooks/useUser';

import { UserType } from 'routes/Dashboard';

import type { DrawerProps } from '../types';
import Drawer from '..';

import menuStyles, {
  LIST_TEXT_PRIMARY_LOGOUT,
  LIST_TEXT_PRIMARY_NAV,
} from './styles';

type RouteEntry = {
  path: string;
  name: string;
  Icon: ElementType;
};

const drawerProfessionalRoutes: RouteEntry[] = [
  { path: Route.DASHBOARD, name: 'Menu Inicial', Icon: HomeOutlinedIcon },
  {
    path: Route.REPORT,
    name: 'Cadastrar paciente',
    Icon: PersonAddOutlinedIcon,
  },
  { path: Route.PACIENT, name: 'Pacientes', Icon: PeopleOutlinedIcon },
];

const drawerPacientRoutes: RouteEntry[] = [
  { path: Route.DASHBOARD, name: 'Menu Inicial', Icon: HomeOutlinedIcon },
  { path: Route.REPORT, name: 'Meus dados', Icon: PersonOutlinedIcon },
  { path: Route.EVOLUTION, name: 'Evolução', Icon: TrendingUpOutlinedIcon },
];

const Menu = ({ onClose, isOpen, anchor }: DrawerProps): JSX.Element => {
  const navigate = useNavigate();
  const { user, wipeUser } = useUser();
  const { wipeToken } = useToken();

  const handleLogout = useCallback(() => {
    wipeToken();
    wipeUser();
    onClose();
    navigate(Route.ROOT);
  }, [navigate, onClose, wipeToken, wipeUser]);

  const RoutesList = useMemo(
    () => (
      <List disablePadding aria-label="Navegação principal">
        {(user.type === UserType.PROFESSIONAL
          ? drawerProfessionalRoutes
          : drawerPacientRoutes
        ).map(({ path, name, Icon }) => {
          const linkState =
            // eslint-disable-next-line no-nested-ternary
            user.type === UserType.PROFESSIONAL
              ? null
              : path === Route.REPORT || path === Route.EVOLUTION
                ? { id: user.id }
                : null;

          return (
            <ListItem key={path} disablePadding sx={menuStyles.listItem}>
              <ListItemButton
                component={Link}
                to={path}
                state={linkState}
                onClick={onClose}
                aria-label={name}
              >
                <ListItemIcon sx={menuStyles.listItemIcon}>
                  <Icon fontSize="small" aria-hidden />
                </ListItemIcon>
                <ListItemText
                  primary={name}
                  slotProps={{ primary: LIST_TEXT_PRIMARY_NAV }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    ),
    [onClose, user.id, user.type],
  );

  return (
    <Drawer open={isOpen} anchor={anchor} onClose={onClose} title="Menu">
      <Box sx={menuStyles.navRoot}>
        {RoutesList}
        <Divider sx={menuStyles.divider} />
        <List disablePadding>
          <ListItem disablePadding>
            <ListItemButton onClick={handleLogout} aria-label="Sair da conta">
              <ListItemIcon sx={menuStyles.listItemIcon}>
                <LogoutOutlinedIcon fontSize="small" aria-hidden />
              </ListItemIcon>
              <ListItemText
                primary="Sair"
                slotProps={{ primary: LIST_TEXT_PRIMARY_LOGOUT }}
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );
};

export default Menu;
